import './base'
import { NewsList, ProjectCtaBar } from 'src/news'
import { NewsAdminBox } from 'src/ppp/news_admin_box'
import { AdminBox, mountOnId } from 'src/shared'

document.addEventListener('DOMContentLoaded', () => {
  mountOnId(NewsList, 'news-list')
  mountOnId(ProjectCtaBar, 'project-cta-bar')
  mountOnId(AdminBox, 'admin-box')
  mountOnId(NewsAdminBox, 'project-news-admin-box')
})
